import { Collab } from "./types";

export const getNativeAppConfig = () => ({
  type: Collab.GET_CONFIG
})

export const getNativeAppConfigSuccess = (nativeAppConfig) => ({
  type: Collab.GET_CONFIG_SUCCESS,
  nativeAppConfig
})

export const getNativeAppConfigFailure = (error) => ({
  type: Collab.GET_CONFIG_FAILURE,
  error
})